import Spacer from '../components/Spacer';
import { artists } from '../data/artists';
import { motion } from 'framer-motion';

function Artist({ id, name, bio, photo /* bioLinks */ }) {
  return (
    <motion.div
      className="flex flex-col lg:w-1/2 items-center sm:w-full mb-20 px-6"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6 }}
    >
      <motion.img
        src={photo}
        className="w-48 h-48 md:w-60 md:h-60 rounded-full object-cover shadow-lg ring-4 ring-golden/20"
        alt={`${name}`}
        whileHover={{ scale: 1.05 }}
        transition={{ duration: 0.3 }}
      />
      <h2 className="text-3xl md:text-4xl font-righteous mt-6 mb-8 text-golden">{name}</h2>
      <div className="max-w-2xl">
        {bio.map((p, index) => (
          <p className="leading-7 md:leading-8 px-4 text-center py-2 text-gray-700 text-base md:text-lg" key={index}>
            {p}
          </p>
        ))}
        {id === 'olsi-gjeci' ? (
          <p className="text-center mt-4 text-base md:text-lg">
            Olsi is founder of the global dance platform{' '}
            <a
              href="https://umuv.world/"
              target="_blank"
              rel="noreferrer"
              className="text-golden underline hover:text-gray-700 transition-colors cursor-pointer font-semibold"
            >
              UMUV
            </a>
          </p>
        ) : null}
      </div>
      <Spacer twUnit="m" amount="6" />
    </motion.div>
  );
}

function Direction() {
  return artists.direction.map(({ id, name, bio, photo /* bioLinks */ }) => {
    return <Artist {...{ id, name, bio, photo /* bioLinks */ }} />;
  });
}

export function Dancers() {
  return artists.dancers.map(({ name, bio, photo }) => {
    return <Artist {...{ name, bio, photo }} />;
  });
}

function MainPageHeader({ title }) {
  return (
    <motion.h1
      className="text-5xl md:text-6xl font-righteous py-16 md:py-20 text-golden text-center mt-10"
      initial={{ opacity: 0, y: -20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      {title}
    </motion.h1>
  );
}

function Company() {
  return (
    <div className="bg-zinc-100 flex flex-col w-full justify-center items-center min-h-screen py-10">
      <MainPageHeader title="DIRECTION" />
      <div className="flex flex-wrap justify-center w-full">
        <Direction />
      </div>
      <MainPageHeader title="DANCERS" />
      <div className="flex flex-wrap justify-center w-full">
        <Dancers />
      </div>
      <div className="pb-10" />
    </div>
  );
}

export default Company;
